import { navigateToUrl } from 'single-spa';

global.autodoc = {
  ...global.autodoc,
  navigateToUrl,
};
